module.exports = __webpack_public_path__ + "media/winner_double_line_4.ba655043.mp3";